import Cookies from 'js-cookie';
import _metrix from 'metrix/metrix';
import qs from 'query-string';

function metrix() {
	let parseLocation = qs.parse(window?.location?.search, { parseNumbers: true, parseBooleans: true });
	const prevUniqueDeviceId = Cookies.get('_uniqueDeviceId');
	let uniqueDeviceId = parseLocation?.gps_adid;

	if (uniqueDeviceId !== undefined) {
		Cookies.set('_uniqueDeviceId', uniqueDeviceId);
	}

	const _metrixSetup = _metrix.initialize({
		appId: 'lhhojbczupeiipq',
		...((uniqueDeviceId || prevUniqueDeviceId) && { uniqueDeviceId: uniqueDeviceId || prevUniqueDeviceId }),
		// uniqueDeviceId: 'fe3343ff444r4',
		// trackerToken: 'rebhyh',
		// storeName: 'GooglePlay',
	});

	return _metrixSetup;
}

export { metrix };
